import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const RawIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 30 34" {...props}>
      <path
        d="M2.24998 0H20.305L29.8749 9.53278V31.875C29.8749 33.049 28.923 34 27.75 34H2.24998C1.07695 34 0.125 33.049 0.125 31.875V2.12498C0.125 0.950958 1.07706 0 2.24998 0Z"
        fill="#DAE0EA"
      />
      <path
        d="M29.8442 9.56273H22.4375C21.2644 9.56273 20.3125 8.61078 20.3125 7.43775V0.0214844L29.8442 9.56273Z"
        fill="#C0C5CD"
      />
    </SvgIcon>
  );
};

export default RawIcon;
